export enum ExecutionStatus {
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED", 
    FAILED = "FAILED",
    PARTIALLY_FAILED = "PARTIALLY_FAILED"
}
